export enum ModalId {
  AcceptAllMatchSuggestionsModal = 'accept-all-match-suggestions-modal',
  AccountFromTemplateModalCreate = 'account-from-template-modal-create',
  AccountFromTemplateModalCreateConfirmation = 'account-from-template-modal-create-confirmation',
  AccountFromTemplateModalEdit = 'account-from-template-modal-edit',
  AccountingBasisConfirmationModal = 'accounting-basis-confirmation-modal',
  AccountingPackageModal = 'accounting-package-modal',
  AnnualReportLateWarningModalDIY = 'annual-report-late-warning-modal-diy',
  AnnualReportLateWarningModalAccountingPackage = 'annual-report-late-warning-modal-accounting-package',
  AnnualReportLateWarningModalCompletePlan = 'annual-report-late-warning-modal-complete-plan',
  AddCurrencyDefaultPaymentMethodModal = 'add-currency-default-payment-method-modal',
  ApproveInvoiceModal = 'approve-invoice-modal',
  AttachmentPreviewModal = 'attachment-preview-modal',
  ReceiptAutoForwardInfoModal = 'receipt-autoforward-info-modal',
  AttachmentsModal = 'attachments-modal',
  AutomaticPaymentRemindersModal = 'automatic-payment-reminders-modal',
  BankAccountOrphanedModal = 'bank-account-orphaned-modal',
  BankConnectionAddAccountModal = 'bank-connection-add-account-modal',
  BankConnectionErrorModal = 'bank-connection-error-modal',
  BankConnectionExpiredModal = 'bank-connection-expired-modal',
  BankConnectionFailedModal = 'bank-connection-failed-modal',
  BankConnectionRemoveConfirmationModal = 'bank-connection-remove-confirmation-modal',
  BankConnectionSuccessModal = 'bank-connection-success-modal',
  BankSettingsModal = 'bank-settings-modal',
  BankTransactionCurrencyMismatchModal = 'bank-transaction-currency-mismatch-modal',
  BankTransactionDrawerDiscardModal = 'bank-transaction-drawer-discard-modal',
  BillDeleteConfirmationModal = 'bill-delete-bill-confirmation',
  BillReconciliationModal = 'bill-reconciliation-modal',
  BillRegisterPaymentModal = 'bill-register-payment-modal',
  BillyWelcomeModal = 'billy-welcome-modal',
  BlockCancelInvoiceActionModal = 'block-cancel-invoice-action-modal',
  BlockCreateDepositInvoiceActionModal = 'block-create-deposit-invoice-action-modal',
  BlockCreateInvoiceActionModal = 'block-create-invoice-action-modal',
  CpaAttachmentInfoModal = 'cpa-attachment-info-modal',
  CompanyInformationModal = 'company-information-modal',
  ContactsImportModal = 'contacts-import-modal',
  ConvertQuoteToDepositInvoiceConfirmationModal = 'convert-quote-to-deposit-invoice-confirmation-modal',
  CreateBankConnectionModal = 'create-bank-connection-modal',
  CreateContactModal = 'create-contact-modal',
  CreateContactPersonModal = 'create-contact-person-modal',
  CreateDepositInvoiceEntryPointModal = 'create-deposit-invoice-entry-point-modal',
  CreateManualPaymentModal = 'create-manual-payment-modal',
  CreateOrEditAccessTokenModal = 'create-or-edit-access-token-modal',
  CreateOrEditAdditionalFieldModal = 'create-or-edit-additional-field-modal',
  CreateOrEditVatAccountModal = 'create-or-edit-vat-account-modal',
  CreateRulesetModal = 'create-ruleset-modal',
  CustomerModal = 'customer-modal',
  DaybookConsequencesModal = 'daybook-consequences-modal',
  DebtCollectionNoteModal = 'debt-collection-note-modal',
  DemoInvoiceCompletedModal = 'demo-invoice-completed-modal',
  DemoInvoiceSendAsEInvoiceModal = 'demo-invoice-send-as-e-invoice-modal',
  DemoInvoiceSendAsEmailModal = 'demo-invoice-send-as-email-modal',
  DeleteContactConfirmationModal = 'delete-contact-confirmation-modal',
  DeleteActorConfirmationModal = 'delete-actor-confirmation-modal',
  DeleteInvoiceDraftModal = 'delete-invoice-draft-modal',
  DeleteOrganizationIconModal = 'delete-organization-icon-modal',
  DeleteOrganizationLogoModal = 'delete-organization-logo-modal',
  DeleteProductsConfirmationModal = 'delete-products-confirmation-modal',
  DeleteProductUnitsConfirmationModal = 'delete-product-units-confirmation-modal',
  DeleteReceiptsConfirmationModal = 'delete-receipts-confirmation-modal',
  DeleteTrialDataModal = 'delete-trial-data-modal',
  DepositInvoiceDetailsModal = 'deposit-invoice-details-modal',
  DirtyRouteModal = 'dirty-route-modal',
  DisableDebtCollectionModal = 'disable-debt-collection-modal',
  DisableMobilePayModal = 'disable-mobilepay-modal',
  DisableStripeModal = 'disable-stripe-modal',
  DisconnectStripeAccountModal = 'disconnect-stripe-account-modal',
  DepositInvoiceUnavailableModal = 'deposit-invoice-unavailable-modal',
  DocumentsCreateFolderActionModal = 'documents-create-folder-action-modal',
  DocumentsMoveItemModal = 'move-item-modal',
  DuplicatedBillActionModal = 'duplicated-bill-action-modal',
  DuplicatedReceiptsActionModal = 'duplicated-receipts-action-modal',
  EditConnectedBankAccountModal = 'edit-connected-bank-account-modal',
  EditManualBankAccountModal = 'edit-manual-bank-account-modal',
  EInvoiceApprovalConfirmationModal = 'e-invoice-approval-confirmation-modal',
  EInvoiceDisputeModal = 'e-invoice-dispute-modal',
  EInvoiceRejectionModal = 'e-invoice-rejection-modal',
  EInvoiceSuspendModal = 'e-invoice-suspend-modal',
  EmailRateExceeded = 'email-rate-exceeded-modal',
  EnableDebtCollectionModal = 'enable-debt-collection-modal',
  EnableEInvoicingModal = 'enable-einvoicing-modal',
  DisableEInvoicingModal = 'disable-e-invoicing-modal',
  EnableMobilePayModal = 'enable-mobilepay-modal',
  EnableStripeModal = 'enable-stripe-modal',
  ExportAsSaftModal = 'export-as-saft-modal',
  ExternalInvoicesSyncModal = 'external-invoices-sync-modal',
  FecImportCancelImportModal = 'fec-import-cancel-import-modal',
  FecImportResumeDeleteModal = 'fec-import-resume-delete-modal',
  FecImportSkipFailedFileModal = 'fec-import-skip-failed-file-modal',
  FirstInvoiceModal = 'first-invoice-modal',
  FrodaFailedModal = 'froda-failed-modal',
  FrodaLendingEligibilityModal = 'froda-lending-eligibilty-modal',
  FrodaProcessingModal = 'froda-processing-modal',
  HelpModal = 'help-modal',
  ImportedInvoicesUploadInfoModal = 'imported-invoices-upload-info-modal',
  InvoiceCancellationModal = 'invoice-cancellation-modal',
  InvoiceDateModal = 'invoice-date-modal',
  InvoiceEditorConfirmApprovalModal = 'invoice-editor-confirm-approval-modal',
  InvoiceEditorConfirmSendByEmailModal = 'invoice-editor-confirm-send-by-email-modal',
  InvoiceEditorDownloadAsXRechnungModal = 'invoice-editor-download-as-xrechnung-modal',
  InvoiceEditorInvoicePrefixAndNumberModal = 'invoice-editor-invoice-prefix-and-number-modal',
  InvoiceEditorLeavePreviewModal = 'invoice-editor-leave-preview-modal',
  InvoiceEditorMissingComplianceDetailsModal = 'invoice-editor-missing-compliance-details-modal',
  InvoiceEditorPaymentMethodsModal = 'invoice-editor-payment-methods-modal',
  InvoiceEditorQuoteNumberModal = 'invoice-editor-quote-number-modal',
  InvoiceEditorSendAsEInvoiceModal = 'invoice-editor-send-as-e-invoice-modal',
  InvoiceEditorSendAsEmailModal = 'invoice-editor-send-as-email-modal',
  InvoicingSettingsModal = 'invoicing-settings-modal',
  InvoicingSettingsUnsavedChangesModal = 'invoicing-settings-unsaved-changes-modal',
  LegalGuaranteeOfConformityModal = 'legal-guarantee-of-conformity-modal',
  LegalMentionsModal = 'legal-mentions-modal',
  MarkQuoteAsAcceptedConfirmationModal = 'mark-quote-as-accepted-confirmation-modal',
  MobileSignupWelcomeModal = 'mobile-signup-welcome-modal',
  OpenBankingAutoConnectModal = 'open-banking-auto-connect-modal',
  OrganizationSettingsInviteBookkeeper = 'organization-settings-invite-bookkeeper-modal',
  OrganizationSettingsInviteUsersModal = 'organization-settings-invite-users-modal',
  OrganizationSettingsRemoveBookkeeperModal = 'organization-settings-remove-bookkeeper-modal',
  OrganizationSettingsRemoveUserModal = 'organization-settings-remove-user-modal',
  OrganizationSettingsTransferOwnershipModal = 'organization-settings-transfer-ownership-modal',
  PeriodicLockReminderModal = 'periodic-lock-reminder-modal',
  PlanConfirmationModal = 'plan-confirmation-modal',
  ProductEditorModal = 'product-editor-modal',
  ProductsImportModal = 'products-import-modal',
  ProductUnitModal = 'product-unit-modal',
  ReadyToApproveSuggestionsModal = 'ready-to-approve-suggestions-modal',
  QuoteDeleteConfirmationModal = 'quote-delete-confirmation-modal',
  RecurringInvoiceEditEmailTemplateModal = 'recurring-invoice-edit-email-template-modal',
  RecurringInvoiceMarkAsCompletedConfirmationModal = 'recurring-invoice-mark-as-completed-confirmation-modal',
  RegisterInternationallyFailedModal = 'registration-internationally-failed-modal',
  RegisterInternationallyFormModal = 'register-internationally-form-modal',
  RegisterInternationallyPendingModal = 'registration-internationally-pending-modal',
  RegisterInternationallySuccessModal = 'registration-internationally-success-modal',
  ReviewEntriesBulkValidateConfirmationModal = 'review-entries-bulk-validate-confirmation-modal',
  ScoutConnectionConnectedModal = 'scout-connection-connected-modal',
  ScoutConnectionDeletionModal = 'scout-connection-deletion-modal',
  ScoutConnectionErrorModal = 'scout-connection-error-modal',
  ScoutConnectionImapModal = 'scout-connection-imap-modal',
  SendAsEInvoiceModal = 'send-as-e-invoice-modal',
  SendAsEmailModal = 'send-as-email-modal',
  SendEInvoiceRequirementsModal = 'send-e-invoice-requirements-modal',
  SendInvoiceModal = 'send-invoice-modal',
  SendPaymentReminderModal = 'send-payment-reminder-modal',
  SupplierPaymentModal = 'supplier-payment-modal',
  SupplierStatementExportModal = 'supplier-statement-export-modal',
  SkipAndCompleteSyncModal = 'skip-and-complete-sync-modal',
  SkipQuickStartConfirmationModal = 'skip-quick-start-confirmation-modal',
  SubscriptionPeriodChangeModal = 'subscription-period-change-modal',
  TrialEndedModal = 'trial-ended-modal',
  UmbrellaCreateRoleModal = 'umbrella-create-role-modal',
  UmbrellaInviteOrUpdateUserModal = 'umbrella-invite-or-update-user-modal',
  UmbrellaTransferOwnershipModal = 'umbrella-transfer-ownership',
  UnmatchConfirmationModal = 'unmatch-confirmation-modal',
  UnrecognizedVatRatesModal = 'unrecognized-vat-rates-modal',
  UpdateProductsVatConfirmationModal = 'update-products-vat-confirmation-modal',
  UpgradeSubscriptionModal = 'upgrade-subscription-modal',
  VATConfirmationModal = 'vat-confirmation-modal',
  VatDeclarationsChangePeriodModal = 'vat-declarations-change-period-modal',
  VatDeclarationsExportModal = 'vat-declarations-export-modal',
  VatDeclarationsDefinePayoutModal = 'vat-declarations-define-payout-modal',
  VatDeclarationsRegisterPeriodPaymentModal = 'vat-declarations-register-period-payment-modal',
  VatDeclarationsSettlePeriodModal = 'vat-declarations-settle-period-modal',
  VatDeclarationsVoidPeriodPaymentModal = 'vat-declarations-void-period-payment-modal',
  VatDeclarationsVoidPeriodSettlementModal = 'vat-declarations-void-period-settlement-modal',
  VatExemptionMentionModal = 'vat-exemption-mention-modal',
  VatExemptionMentionInfoModal = 'vat-exemption-mention-info-modal',
  ViewAccessTokenModal = 'view-access-token-modal',
  VoidBillConfirmationModal = 'void-bill-confirmation-modal',
  VoidInvoiceModal = 'void-invoice-modal',
  DeleteOrganizationOwnerModal = 'delete-organization-owner-modal',
  InvoiceReconciliationModal = 'invoice-reconciliation-modal',
  HideAccountModal = 'hide-account-modal',
  DocumentsFirstTimeModal = 'documents-first-time-modal',
  DocumentsMigrationDoneModal = 'documents-migration-done-modal',
  DocumentsPreviewModal = 'documents-preview-modal',
  DocumentsFileListDeleteModal = 'documents-file-list-delete-modal',
  DocumentsFolderDeleteModal = 'documents-folder-delete-modal',
}
